import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { Subject } from 'rxjs';

import { SelectBox } from 'cbc-shared-lib';

import { SgKdConstants } from '../../../../../sg-kd-shared/sg-kd-constants';

@Component({
  selector: 'app-sgkd002d-crd',
  templateUrl: './sgkd002d-crd.component.html',
  styleUrl: './sgkd002d-crd.component.scss'
})
export class Sgkd002dCrdComponent implements OnInit, OnDestroy {

  private onDestroy$ = new Subject();

  /** メインフォーム */
  @Input() mainForm: UntypedFormGroup;
  /** クレ企業名コードリスト */
  @Input() codeCreComAnameList: SelectBox[];

  /** クレジットフォーム */
  creditForm: UntypedFormGroup;

  constructor(
    private formBuilder: UntypedFormBuilder) {
  }

  /**
   * 初期処理
   * 
   * @memberof Sgkd002dCrdComponent
   */
  ngOnInit(): void {
    this.creditForm = this.createCreditForm();
    this.mainForm.addControl("creditForm", this.creditForm);
  }

  /**
   * 破棄処理
   * 
   * @memberof Sgkd002dCrdComponent
   */
  ngOnDestroy(): void {
    this.mainForm.removeControl("creditForm");
    this.onDestroy$.next();
  }

  /**
   * クレジットフォームの生成
   * 
   * @returns - クレジットフォーム
   * @memberof Sgkd002dCrdComponent
   */
  private createCreditForm(): UntypedFormGroup {
    return this.formBuilder.group({
      // クレ企業コード
      crdcomCoCode: new UntypedFormControl(
        { value: '', disabled: false },
        [ Validators.required ]
      ),
      crdcoCodeNm: new UntypedFormControl({ value: '', disabled: true }, Validators.required),
      // カード名義（カナ）
      cardMeigiKana: new UntypedFormControl(
        { value: '', disabled: false },
        [
          Validators.required,
          Validators.maxLength(SgKdConstants.SGKD002D.MAX_LENGTH.CARD_MAIGI_KANA),
          Validators.pattern(SgKdConstants.PATTERN.ZEN_KANA)
        ]
      ),
      // DBキー
      crdLinkKey: new UntypedFormControl(
        { value: '', disabled: false },
        [
          Validators.required,
          Validators.minLength(SgKdConstants.SGKD002D.MAX_LENGTH.CRD_LINK_KEY),
          Validators.maxLength(SgKdConstants.SGKD002D.MAX_LENGTH.CRD_LINK_KEY)
        ]
      ),
    });
  }

  /**
   * クレ企業名変更
   * 
   * @memberof Sgkd002dCrdComponent
   */
  changeCrdcoCodeNm(): void {
    this.creditForm.get('crdcoCodeNm').setValue(this.codeCreComAnameList
                         .find(code => code.value == this.creditForm.get('crdcomCoCode')?.value)
                         .viewValue);
  }
}
